<template>
  <div class="payStatus">
    <!-- 头部登录 -->
    <Header-Top> </Header-Top>
    <div class="main w">
      <div class="main-top">
        <img
          src="@/assets/images/home/AIRPLEX.png"
          alt=""
          style="vertical-align: sub; width: 171px; height: 55px"
        />
        <span class="span-2">收银台</span>
        <span>正见 · 正心 · 正品</span>
      </div>
      <div class="main-center" v-show="this.status == 0">
        <Alert type="warning" show-icon>
          {{ count }}秒后关闭，即将进入我的【订单页面】重新支付
        </Alert>
        <span class="iconfont icon-a-zu417"></span>
        <p>页面已过期</p>
        <br />

        <Button to="/bought">查看订单</Button>
      </div>
      <div class="main-center" v-show="this.status == 1">
        <Alert type="success" show-icon>
          {{ count }}秒后关闭，即将进入我的【订单页面】
        </Alert>
        <span class="iconfont icon-a-lujing228"></span>
        <p>支付成功</p>
        <br />
        <Button to="/bought">查看订单</Button>
      </div>
      <div class="main-center" v-show="this.status == 2">
        <Alert type="error" show-icon>
          {{ count }}秒后关闭，即将进入我的【订单页面】
        </Alert>
        <span class="iconfont icon-a-zu4451"></span>
        <p>支付失败</p>
        <br />
        <Button to="/bought">查看订单</Button>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderTop from '../base/common/header-top.vue'

export default {
  name: 'payStatus',
  components: { HeaderTop },
  data() {
    return {
      count: '', //倒计时
      status: this.$route.query.status
    }
  },
  created() {
    this.threeGo()
    console.log(this.status)
  },
  methods: {
    threeGo() {
      const TIME_COUNT = 3
      if (!this.timer) {
        this.count = TIME_COUNT
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            clearInterval(this.timer)
            this.timer = null
            this.$router.push({
              path: '/bought'
            })
          }
        }, 1000)
      }
    }
  },
  computed: {},
  watch: {}
}
</script>
<style lang='less' scoped>
.payStatus {
  .w {
    width: 1200px;
    margin: 0 auto;
  }
  .main {
    margin-top: 76px;
    .main-top {
      clear: both;
      padding-bottom: 10px;
      border-bottom: 1px solid #e2e2e2;
      .span-2 {
        font-size: 14px;
        color: #787878;
        padding-left: 7px;
      }
      span:last-child {
        font-size: 16px;
        color: #787878;
        float: right;
        padding-top: 33px;
      }
    }
    .main-center {
      padding-top: 20px;
      text-align: center;
      .ivu-alert {
        width: 500px;
        margin: 0 auto;
      }
      .iconfont {
        font-size: 100px;
      }
      p {
        font-size: 20px;
        color: #434343;
      }
      .icon-a-zu417 {
        color: #ff8a24;
      }

      .icon-a-lujing228 {
        color: #35b94f;
      }
      .icon-a-zu4451 {
        color: #e90d0d;
      }
    }
    .three {
    }
  }
}
</style>